<template>
    <v-dialog :persistent="persistent" :value="value" max-width="500px" @keydown.esc.prevent="cancel">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <span v-if="context">&nbsp;({{ context }})</span>
            </v-card-title>

            <v-card-text v-html="message"></v-card-text>

            <v-card-actions>
                <slot name="actions">
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
                    <v-btn color="action" text @click="confirm">{{ confirmLabel }}</v-btn>
                    <v-btn v-if="confirmAlternateLabel" color="action" text @click="confirmAlternate">{{
                        confirmAlternateLabel
                    }}</v-btn>
                </slot>
            </v-card-actions>
        </v-card>
        <template #activator="{ attrs, on }">
            <slot name="activator" :attrs="attrs" :on="on"></slot>
        </template>
    </v-dialog>
</template>

<script>
import { getI18nInstance as i18n } from '@/i18n';

export default {
    name: 'ConfirmDialog',

    props: {
        title: {
            type: String,
            default: () => i18n().t('rec_delete'),
        },
        message: {
            type: String,
            default: () => i18n().t('confirm_rec_delete'),
        },
        // context is the additional text to be displayed in the confirm message,
        // e.g. "Delete (<context>)" --> "Delete (user x)"
        context: {
            type: String,
            default: null,
        },
        persistent: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Boolean,
            required: true,
        },
        confirmLabel: {
            type: String,
            default: () => i18n().t('confirm').toLowerCase(),
        },
        confirmAlternateLabel: {
            type: String,
            default: null,
        },
    },

    methods: {
        cancel() {
            this.$emit('cancel');
            this.$emit('input', false);
        },

        confirm() {
            this.$emit('confirm');
            this.$emit('input', false);
        },

        confirmAlternate() {
            this.$emit('confirm-alternate');
            this.$emit('input', false);
        },
    },
};
</script>
